<app-ui-auth-card title="Login to your account" description="Enter your email below to login to your account">
  @if (!mfaChallenge()) {
    <form #loginForm="ngForm" (ngSubmit)="loginWithUserPass(loginForm)">
      <div class="flex w-full flex-col gap-[calc(var(--spacing)*7)]">
        <app-ui-field label="Email" inputId="login-email">
          <input
            id="login-email"
            appUiInput
            name="email"
            type="email"
            autocomplete="email"
            data-testid="login-email"
            placeholder="email@example.com"
            [(ngModel)]="loginData.email"
            required
            email
            #emailModel="ngModel"
            [attr.aria-invalid]="emailModel.invalid && (emailModel.touched || loginForm.submitted)"
          />
        </app-ui-field>

        <app-ui-field label="Password" inputId="login-password">
          <a
            labelAction
            class="forgot-password ml-auto text-sm text-muted-foreground underline-offset-4 hover:text-primary hover:underline"
            [routerLink]="['/login/reset-password']"
          >
            Forgot password?
          </a>
          <input
            id="login-password"
            appUiInput
            name="password"
            type="password"
            autocomplete="current-password"
            data-testid="login-password"
            [(ngModel)]="loginData.password"
            required
            #passwordModel="ngModel"
            [attr.aria-invalid]="passwordModel.invalid && (passwordModel.touched || loginForm.submitted)"
          />
        </app-ui-field>

        <p class="min-h-8 text-sm leading-5 text-destructive" data-testid="login-error" [class.invisible]="!loginFailed()" aria-live="polite">
          {{ loginFailed() ? loginErrorMessage() : ' ' }}
        </p>

        <div class="flex w-full flex-col gap-[calc(var(--spacing)*3)]">
          <button
            appUiButton
            class="w-full"
            type="submit"
            data-testid="login-submit"
            [disabled]="loading() || (loginForm.submitted && loginForm.invalid)"
          >
            @if (!loading()) {
              <span>Login</span>
            } @else {
              <span>Logging in...</span>
            }
          </button>

          <p class="text-center text-sm text-muted-foreground">
            Don't have an account?
            <a class="underline underline-offset-4 hover:text-primary" routerLink="/login/create-account">Sign up</a>
          </p>
        </div>
      </div>
    </form>
  } @else {
    <form (ngSubmit)="verifyMfa()" class="flex flex-col gap-8">
      <p class="text-sm text-muted-foreground">
        We emailed a six-digit code to your verified account email. It expires in {{ mfaExpiryMinutes }} minutes.
      </p>
      <app-ui-field label="Security code" inputId="login-mfa-code">
        <input
          id="login-mfa-code"
          appUiInput
          name="mfaCode"
          inputmode="numeric"
          autocomplete="one-time-code"
          maxlength="6"
          pattern="[0-9]{6}"
          data-testid="login-mfa-code"
          [(ngModel)]="mfaCode"
          required
        />
      </app-ui-field>
      <p class="min-h-8 text-sm leading-5 text-destructive" data-testid="login-error" [class.invisible]="!loginFailed()" aria-live="polite">
        {{ loginFailed() ? loginErrorMessage() : ' ' }}
      </p>
      <button
        appUiButton
        class="login-mfa-submit"
        type="submit"
        data-testid="login-mfa-submit"
        [disabled]="loading() || mfaCode().length !== 6"
      >
        {{ loading() ? 'Verifying...' : 'Verify and login' }}
      </button>
      <button class="login-mfa-resend text-sm underline" type="button" (click)="resendMfa()">Resend code</button>
    </form>
  }
</app-ui-auth-card>
